import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AppInitializer } from './app.init';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  private readonly appInitializer = inject(AppInitializer);

  constructor() { }

  async ngOnInit(): Promise<void> {
    await this.appInitializer.initialize();
  }
}
